import React, { useState, useEffect, useRef } from 'react';
import RecruitModal from '../Modal/RecruitModal'; // モーダルを別ファイルに分離


const jobList = [
    {
        title: 'ダイレクトマーケティングメンバー',
        category: 'エンジニア',
        description: 'データ分析を活用した効果的なマーケティング戦略の企画・実行を担当します。',
        skills: '必須スキルなし<br/>接客経験者・営業経験者歓迎・業界不問',
        location: '各営業先',
    },
    {
        title: 'ウェルケアケアメンバー',
        category: 'デザイナー',
        description: '介護・福祉施設での利用者ケアや施設運営サポート業務を行います。',
        skills: '看護・介護経験者<br/>看護師資格・准看護師資格・介護福祉士・関連資格者歓迎',
        location: '埼玉県',
    },
    {
        title: '営業（本社営業）',
        category: '未経験',
        description: 'クライアントとの折衝業務やサービス提案を行い、企業との信頼関係を築きます。研修制度あり。',
        skills: '運転免許　営業経験必須　社会人経験5年以上',
        location: '都内',
    }
];

const testimonials = [
    {
        name: 'Aさん 男性/30代',
        message: '代表や社長、オーナーがイベントを推奨して社員で意見を出し合い、自分たちの意見が反映されたイベントが開催できます。みんなが笑顔で仕事をするために、全力でイベントも楽しみ、仕事も全力で楽しもうという社風です。',
    },
    {
        name: 'Bさん 男性/20代',
        message: '自分の力量を社長と面談し評価してもらえる場がある会社です。直接面談ができることから、自分がどう評価してもらえてるのかがダイレクトに知ることができるのですごく自分にとってスキルアップや方向性の修正が出来るいい会社です。',
    },
    {
        name: 'Cさん 男性/20代',
        message: '販売職での取引先の会社様からの依頼がものすごく多く、人不足により依頼を受けきれないほどです。その背景には社員一人ひとりの意識の高さ、スキルの高さが弊社を求めていただけている最大の要因であると思います。',
    },
];

function RecruitSection() {
    const [selectedJob, setSelectedJob] = useState(null);
    const [activeCat, setActiveCat] = useState('すべて');
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [shouldAnimate, setShouldAnimate] = useState(false);

    useEffect(() => {
        let hasAppeared = false;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                if (!hasAppeared) {
                    setShouldAnimate(true);
                    hasAppeared = true;
                }
                setVisible(true);
            } else {
                setVisible(false);
                hasAppeared = false;
            }
        }, { threshold: 0.2 });
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (selectedJob) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [selectedJob]);

    const filteredJobs = activeCat === 'すべて'
        ? jobList
        : jobList.filter(job => job.category === activeCat);

    return (
        <section
            id="recruit"
            ref={ref}
            className={`backdrop-blur-md rounded-3xl p-6 md:p-12 shadow-2xl border border-cyan-200/20 hover:border-cyan-300/30 mb-16 max-w-5xl mx-auto ${visible ? 'opacity-100' : 'opacity-0'}`}
            style={{
                willChange: 'opacity',
                transition: shouldAnimate ? 'opacity 1.2s cubic-bezier(.4,0,.2,1)' : 'none'
            }}
            onTransitionEnd={() => setShouldAnimate(false)}
        >
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight border-b border-cyan-400/30 pb-2 mb-8">
                Recruit
            </h2>

           

            <div className="grid md:grid-cols-3 gap-6 text-white">
                {filteredJobs.map((job, idx) => (
                    <button
                        key={idx}
                        onClick={() => setSelectedJob(job)}
                        className="bg-gradient-to-br from-orange-400/80 to-red-200/70 p-6 rounded-2xl border border-cyan-400/20 hover:scale-[1.03] transition shadow-xl text-left"
                    >
                        <div className="text-xl font-bold mb-1">{job.title}</div>
                        {/* <div className="text-sm text-blue-100 mb-2">{job.description}</div> */}
                        <span className="text-xs text-purple-200">クリックして詳細を見る →</span>
                    </button>
                ))}
            </div>

            {/* モーダル表示 */}
            {selectedJob && <RecruitModal job={selectedJob} onClose={() => setSelectedJob(null)} />}

            <h3 className="text-2xl font-bold text-white mt-16 mb-6 border-b border-cyan-400/30 pb-2">
                社員の声
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
                {testimonials.map((item, i) => (
                    <div
                        key={i}
                        className="bg-white/10 border border-blue-300 rounded-xl p-6 shadow-xl relative"
                    >
                        <div className="text-sm text-orange-300 font-semibold mb-1">{item.name}</div>
                        <p className="text-sm text-white">{item.message}</p>
                    </div>
                ))}
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-16 text-center text-white">
                <div>
                    <p className="text-5xl font-bold text-cyan-300 animate-pulse">27歳</p>
                    <p className="mt-2 text-sm text-white">平均年齢</p>
                </div>
                <div>
                    <p className="text-5xl font-bold text-purple-300 animate-pulse">5時間以下</p>
                    <p className="mt-2 text-sm text-white">平均残業時間</p>
                </div>
                <div>
                    <p className="text-5xl font-bold text-blue-300 animate-pulse">8:2</p>
                    <p className="mt-2 text-sm text-white">男女比</p>
                </div>
                <div className="md:col-start-2 md:col-end-3">
                    <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-36">
                        <div>
                            <p className="text-5xl font-bold text-green-300 animate-pulse whitespace-nowrap">100%</p>
                            <p className="mt-2 text-sm text-white whitespace-nowrap">社員定着率</p>
                        </div>
                        <div>
                            <p className="text-5xl font-bold text-yellow-300 animate-pulse whitespace-nowrap">18社</p>
                            <p className="mt-2 text-sm text-white whitespace-nowrap">取引企業数</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RecruitSection;
